import {
  Card,
  CardAction,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/shared/components/ui/card";
import { NavLink, useParams } from "react-router";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { ArrowLeft, RefreshCw } from "lucide-react";
import t from "@/lang/lang";
import { Button } from "@/shared/components/ui/button";
import { useHtzVisualAssessmentCatalogShowQuery } from "@/services/backend/htz/inspection/api/visual-assessment-catalog-api";
import { VisualAssessmentCatalogItemsTable } from "@/services/backend/htz/inspection/components/visual-assessment-catalog-items-table";
import { PutVisualAssessmentCatalogItemDialog } from "@/services/backend/htz/inspection/components/put-visual-assessment-catalog-item-dialog";

export function VisualAssessmentCatalogRoute() {
  const { visualAssessmentCatalogId } = useParams();

  const {
    data: catalog,
    isLoading,
    error,
  } = useHtzVisualAssessmentCatalogShowQuery({
    id: visualAssessmentCatalogId!,
  });

  if (error) {
    return <RTKQueryErrorAlert error={error} />;
  }

  if (isLoading) {
    return (
      <Card>
        <CardHeader>
          <CardTitle className="flex space-x-4">
            <RefreshCw className="animate-spin" />
            <span>{t("Lade Katalog")}</span>
          </CardTitle>
        </CardHeader>
      </Card>
    );
  }

  return (
    <div>
      <Card>
        <CardHeader>
          <CardTitle>
            <NavLink to="./..">
              <Button variant="outline" size="sm" className="m-0 mb-4">
                <ArrowLeft className="mr-2 h-4 w-4" />
                <span>{t("Übersicht")}</span>
              </Button>
            </NavLink>
            <div>{catalog!.name}</div>
          </CardTitle>
          <CardDescription>
            {t("Vorlagen für Komponenten einer RLT-Anlage.")}
          </CardDescription>
          <CardAction>
            <PutVisualAssessmentCatalogItemDialog catalogId={catalog!.id} />
          </CardAction>
        </CardHeader>
        <CardContent>
          <VisualAssessmentCatalogItemsTable catalog={catalog!} />
        </CardContent>
      </Card>
    </div>
  );
}
